import React from 'react';
import { getRedirectUrl } from '../utils/helpers';
import { getTimezoneOffsetString } from '../utils/dateHelpers';
import { useDashboard } from '../hooks/useDashboard';
import { PageSkeleton } from '../components/Skeletons/dashboard';
import { usePostModalStore } from '../store/usePostModalStore';
import { useCancelPost } from '../mutations/social';
import { useQueryClient } from '@tanstack/react-query';
import useNotification from '../hooks/useNotification';

import {
  PostList,
  StatsSection,
  ConnectedAccountsSection,
  ProfileInformationSection,
} from '../components/Dashboard';
import NotificationPanel from '../components/NotificationPanel';

const DashboardPage = () => {
  const {
    // Data
    profile,
    displayPosts,
    socialAccounts,
    stats,
    showUpgradeCTA,
    isLoading,
    shouldShowNotification,
    handleCloseNotification,
    handleTryAgain,
  } = useDashboard();
  const { openModal } = usePostModalStore();
  const queryClient = useQueryClient();
  const notification = useNotification();

  const { mutate: cancelPost } = useCancelPost(
    () => {
      notification.success('Post cancelled and reverted to draft.');
      queryClient.invalidateQueries({ queryKey: ['posts'] });
    },
    () => {
      notification.error('Failed to cancel post. Please try again.');
    }
  );

  const handlePostClick = (post) => {
    openModal(post);
  };

  const handleCancelPost = (postId) => {
    cancelPost({ postId, timezone: getTimezoneOffsetString() });
  };

  const redirectUri = getRedirectUrl('/dashboard/products');

  if (isLoading) {
    return <PageSkeleton />;
  }

  return (
    <div className='space-y-8'>
      {/* Profile Information */}
      <ProfileInformationSection profile={profile} />
      {/* Notification panel  */}
      {shouldShowNotification && (
        <NotificationPanel
          variant='info'
          message={
            'Your posts are beeing generated they will be available in a copule of minutes, please reload the app or click the button to refresh'
          }
          actionText={'Refresh'}
          onActionClick={handleTryAgain}
          onClose={handleCloseNotification}
        />
      )}

      {/* Upcoming Posts */}
      <PostList
        posts={displayPosts}
        showUpgradeCTA={showUpgradeCTA}
        redirectUri={redirectUri}
        onPostClick={handlePostClick}
        onCancelPost={handleCancelPost}
      />

      {/* Stats & Connected Accounts Row */}
      <div className='grid grid-cols-1 lg:grid-cols-3 gap-6'>
        <StatsSection stats={stats} />
        <ConnectedAccountsSection socialAccounts={socialAccounts} />
      </div>
    </div>
  );
};

export default DashboardPage;

